export namespace ProfessionalDatas {
  export interface IProfessionalData {
    id: number;
    personId: number;
    professionId: number;
    coverLetter: string;
    professionLevel: number;
    skills: IPersonSkill[];
    firstExperience: string;
    jobValue: number;
    transportVoucherIncluded: boolean;
    maxDistance: number;
  }

  export class ProfessionalData implements IProfessionalData {
    id: number = 0;
    personId: number = 0;
    professionId: number = 0;
    coverLetter: string = "";
    professionLevel: number = -1;
    skills: IPersonSkill[] = new Array<IPersonSkill>();
    firstExperience: string = "";
    jobValue: number = 0;
    transportVoucherIncluded: boolean = false;
    maxDistance: number = 0;
  }

  export interface IPersonSkill {
    id: number;
    personId: number;
    skillId: number;
  }

  export class PersonSkill implements IPersonSkill {
    id: number = 0;
    personId: number = 0;
    skillId: number = 0;
  }
}
